(function($) {
  'use strict';

  $.fn.rlCookiesCampaign = function () {

    var config = {
      cookieId: '',
      currentCookieId: '',
      querystringIdentifier: '',
      querystringValue: '',
      domain: '',
      secure: false
    }

    // Extracts Url parameter key value
    var getUrlParameter = function (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(window.location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Check Cookie
    var getCookie = function () {
      var regex = new RegExp('(?:^|;)\\s?' + config.cookieId + '=(.*?)(?:;|$)', 'i')
      var result = document.cookie.match(regex);
      return (result === null) ? null : unescape(result[1]);
    }

    // Set Cookie
    var setCookie = function () {
      var extraParams = ';';

      if (config.domain !== '') {
        extraParams += config.domain;
      }

      extraParams += ';path=/';
      document.cookie = encodeURIComponent(config.cookieId) + '=' + encodeURIComponent(config.querystringValue) + extraParams;
    }

    // Calculate domain to set cookie on
    var calculateDomain = function () {
        var regex = new RegExp(/\./g);
        var domain = document.location.hostname.toString();
        var count = 0;
        try {
            count = domain.match(regex).length;
        } catch (err) {}

        if (count > 1) {
            domain = domain.substring(domain.indexOf('.') + 1);
            config.domain = ';domain=.' + domain;
        } else {
            config.domain = domain;
        }
    }

    // Process cookie name and query string identifier
    // CRUD for Cookies if needed

    var processCookie = function (name, identifier, secure) {
      // Set params for cookie name and query string to get value form
      calculateDomain();
      config.cookieId = name,
      config.querystringIdentifier = identifier,
      config.currentCookieId = getCookie();

      // Get cookie value from query string
      config.querystringValue = getUrlParameter(config.querystringIdentifier);

      // If query string value isn't empty
      if (config.querystringValue !== '') {
        // If current cookie is empty
        if (config.currentCookieId !== '' || config.currentCookieId !== null ) {
          setCookie();
        }
      }
    }

    // TO-DO
    // Expose the process cookie function or even abstract so it's
    // for all query string params and not just campaign as scope of this
    // ticket states

    $.fn.rlCookiesCampaign.processCookie = processCookie;

    // Init test for campaign cookie RlCampaignCode
    $.fn.rlCookiesCampaign.processCookie('RlCampaignCode', 'utm_campaign');

  }

}(jQuery));



